<template>
  	<div class="versions xhm-layout">
  	  	<div style="margin:10px 0 20px;">
  	  	  	<el-button type="primary" size="small" @click="addVers">新增</el-button>
  	  	</div>

  	  	<el-dialog :title="form.id === null ? '新增' : '编辑'" :visible.sync="dialogForm" :before-close="handleClose">
  	  	  	<el-form :model="form" :rules="rules" ref="ruleForm" label-width="120px" size="small">
  	  	  	  	<el-form-item label="排序号" prop="sort">
					<el-input-number v-model="form.sort" :min="0" :max="1000"></el-input-number>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="版本标题" prop="name">
  	  	  	  	  	<el-input v-model="form.name" maxlength="50" show-word-limit></el-input>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="价格（元）" prop="origin_price">
  	  	  	  	  	<el-input type="number" v-model.number="form.origin_price" onKeypress="return(/[\d]/.test(String.fromCharCode(event.keyCode)))"></el-input>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="有效期（月）" prop="valid_time">
					<el-input-number v-model="form.valid_time" :min="0" :max="12"></el-input-number>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="折扣（%）" prop="discount">
					<el-input-number v-model="form.discount" :min="0" :max="100"></el-input-number>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="是否打折" prop="is_discount">
  	  	  	  	  	<el-select v-model="form.is_discount" placeholder="请选择">
  	  	  	  	  	  	<el-option label="是" :value="1"></el-option>
  	  	  	  	  	  	<el-option label="否" :value="0"></el-option>
  	  	  	  	  	</el-select>
  	  	  	  	</el-form-item>
  	  	  	  	<el-form-item label="是否显示" prop="is_display">
  	  	  	  	  	<el-select v-model="form.is_display" placeholder="请选择">
  	  	  	  	    	<el-option label="是" :value="1"></el-option>
  	  	  	  	    	<el-option label="否" :value="0"></el-option>
  	  	  	  	  	</el-select>
  	  	  	  	</el-form-item>
  	  	  	</el-form>
  	  	  	<div slot="footer" class="dialog-footer">
  	  	  	  	<el-button type="primary" @click="submitForm" size="small" :loading="loading">确 定</el-button>
  	  	  	  	<el-button @click="handleClose" size="small">取 消</el-button>
  	  	  	</div>
  	  	</el-dialog>

		<in-table ref="myTable" :intApi="intApi" :columns="columns" :params="params" @onChange="handleChange"></in-table>

  	</div>
</template>
<script>
import InTable from '@/views/Comm/InTable'
export default {
  	data() {
  	  	return {
			form: {},
			intApi: this.$api.comApi.lbrechergList,
  	  	  	loading: false,
  	  	  	dialogForm: false,
			params: { page: 1, limit: 10 },
			columns: [
				{ prop: 'sort', label: '#', width: 80 },
				{ prop: 'name', label: '标题' },
				{ prop: 'origin_price', label: '价格（元）' },
				{ prop: 'is_display', label: '是否显示', render: (h, { row, column }) => (h('span', row[column.prop] === 0 ? '否' : '是'))},
				{ prop: 'valid_time', label: '有效期（月）' },
				{ prop: 'discount', label: '折扣' },
				{ prop: 'is_discount', label: '是否折扣', render: (h, { row, column }) => (h('span', row[column.prop] === 0 ? '否' : '是'))},
				{ label: '操作', flexd: 'right', width: 100, render: (h, { row }) => {
					return h('el-button', {
						props: { type: 'text', size: 'small' },
						on: { click: () => { this.editor(row) }}
					}, '编辑')
				}},
			],
  	  	  	rules: {
  	  	  	 	name: [ { required: true, message: "请填写版本标题", trigger: "change" } ],
  	  	  	 	// sort: [ { required: true, message: "请填写序号", trigger: "change" } ],
  	  	  	 	valid_time: [{ required: true, message: "请填写有效期", trigger: "change" }],
  	  	  	 	origin_price: [{ required: true, message: "请输入价格", trigger: "change" }],
				is_display: [{ required: true, message: "请选择", trigger: "change" }],
				discount: [{ required: true, message: "请输入折扣", trigger: "change" }]
  	  	  	}
  	  	};
  	},
  	components: {
		InTable	
  	},
	mounted: function () {
		this.getList()
	},
  	methods: {
  	  	getList: function () {
			this.$nextTick(() => { this.$refs.myTable.handleList(this.params) })
  	  	},
  	  	addVers() {
  	  	  	this.form.id = null;
  	  	  	this.dialogForm = true;
  	  	},
  	  	editor(data) {
  	  	  	let { id, name, origin_price, valid_time, is_display, sort, discount, is_discount } = data
  	  	  	this.form = { id, name, origin_price, valid_time, is_display, sort, discount, is_discount }
  	  	  	this.dialogForm = true;
  	  	},
  	  	handleClose() {
  	  	  	this.dialogForm = false;
  	  	  	this.$refs["ruleForm"].resetFields()
  	  	},
  	  	submitForm: function () {
  	  	  	this.$refs["ruleForm"].validate(async valid => {
  	  	  	  	if (!valid) return
				try {
					this.loading = true
					const { status, message } = await this.$api.comApi.lbrechergeSave(this.form)
					this.$message({ showClose: true, message: status === '0' ? '操作成功' : message, type: status === '0' ? 'success' : 'error' })
					if(status === '0'){
						this.handleClose()
						this.getList()
					}
					this.loading = false
				} catch (err) {
					this.loading = false
					this.$message.error(`数据异常：${err}`)
				}
  	  	  	});
		},
		handleChange({ page, limit }){
            let params = Object.assign({}, this.params, { page, limit })
			this.params = params
            this.getList()
        }
  	}
}
</script>